<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
    width="40%"
  >
    <div class="content">
      <div class="header">
        <h1 class="title">Edit Phase Name</h1>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="Phase Name*">
            <b-input
              v-model="phaseName"
              required
              placeholder="Enter phase name..."
            />
          </b-field>
        </div>
      </div>

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'edit-job-phase-modal',

  props: {
    phase: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      phaseName: this.phase.name,
    };
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    onSave() {
      if (!this.phaseName || !this.phaseName.trim()) {
        this.$buefy.toast.open({
          message: 'Please enter a phase name.',
          type: 'is-danger',
          duration: 5000,
        });
        return;
      }
      const trimmed = this.phaseName.trim();
      if (trimmed === this.phase.name) {
        this.$emit('close');
        return;
      }
      this.$emit('onSave', trimmed);
    },
  },
};
</script>

<style scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  min-height: 250px;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
